import _extends from '@babel/runtime-corejs3/helpers/extends';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import _concatInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/concat';
import React__default from 'react';
import { IconData } from '@qualtrics/component-styles';

var _excluded = ["type", "size"];
var IconSizes = {
  small: 16,
  medium: 24,
  large: 32
};

/*
 * Value should be the replacement
 */
var deprecated = {
  Contact: 'User',
  EmptyBox: 'Folder',
  PaginateFilter: 'Copy',
  ParticipantInviteAutomation: 'UserGroup',
  Slider: 'SliderOptions'
};
function deprecationWarning(type) {
  if (deprecated[type]) {
    var _context;
    // eslint-disable-next-line no-console
    console.warn(_concatInstanceProperty(_context = "\"IconTypes.".concat(type, "\" has been deprecated! Use \"IconTypes.")).call(_context, deprecated[type], "\" instead."));
  }
}
var Icon = /*#__PURE__*/React__default.forwardRef(function (_ref, ref) {
  var type = _ref.type,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'medium' : _ref$size,
    rest = _objectWithoutProperties(_ref, _excluded);
  // eslint-disable-next-line no-console
  console.warn("<Icon> component is deprecated! Use individual icon components from the @qualtrics/ui-react/icons import path instead", type);
  deprecationWarning(type);
  var svgContent = IconData[deprecated[type] || type];
  var pixels = IconSizes[size];
  return /*#__PURE__*/React__default.createElement("svg", _extends({}, rest, {
    ref: ref,
    width: pixels,
    height: pixels,
    focusable: "false",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "data-icontype": type,
    dangerouslySetInnerHTML: {
      __html: svgContent
    } // eslint-disable-line react/no-danger
  }));
});

export { Icon };
